"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.encodeData = encodeData;
exports.decodeData = decodeData;
const tslib_1 = require("tslib");
const crypto_js_1 = tslib_1.__importDefault(require("crypto-js"));
function encodeData(data, secret) {
    return crypto_js_1.default.AES.encrypt(data, secret).toString();
}
function decodeData(data, secret) {
    return crypto_js_1.default.AES.decrypt(data, secret).toString(crypto_js_1.default.enc.Utf8);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5jb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZW5jb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBRUEsZ0NBRUM7QUFFRCxnQ0FFQzs7QUFSRCxrRUFBaUM7QUFFakMsU0FBZ0IsVUFBVSxDQUFDLElBQVksRUFBRSxNQUFjO0lBQ25ELE9BQU8sbUJBQVEsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQyxRQUFRLEVBQUUsQ0FBQztBQUN6RCxDQUFDO0FBRUQsU0FBZ0IsVUFBVSxDQUFDLElBQVksRUFBRSxNQUFjO0lBQ25ELE9BQU8sbUJBQVEsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQyxRQUFRLENBQUMsbUJBQVEsQ0FBQyxHQUFHLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDMUUsQ0FBQyJ9